import { render, staticRenderFns } from "./ChannelAndRuleFilterModal.vue?vue&type=template&id=509efab8&scoped=true"
import script from "./ChannelAndRuleFilterModal.vue?vue&type=script&lang=js"
export * from "./ChannelAndRuleFilterModal.vue?vue&type=script&lang=js"
import style0 from "./ChannelAndRuleFilterModal.vue?vue&type=style&index=0&id=509efab8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509efab8",
  null
  
)

export default component.exports